import { render } from "./LandingPage.vue?vue&type=template&id=724a18dc&scoped=true&ts=true"
import script from "./LandingPage.vue?vue&type=script&lang=ts"
export * from "./LandingPage.vue?vue&type=script&lang=ts"

import "./LandingPage.vue?vue&type=style&index=0&id=724a18dc&lang=less&scoped=true"

import exportComponent from "/home/www-fe/fe-prod/workspace/talbook_bfe_h5_base_frame_refs-heads-master/source_code/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-724a18dc"]])

export default __exports__